<template>
  <div class="framework">
    <div class="header">
      <div class="title">解决方案及架构</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="frameworkLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">智慧社区解决方案</div>
        <div class="text">全面的软件系统+智能设备打造软硬一体化</div>
        <div class="item-title">方案优势</div>
        <div class="item" v-for="item in list" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>

    <div class="body1">
      <div class="left">
        <div class="title">物业管理数字化</div>
        <div class="text">
          闭路监控管理、门禁系统、电梯管理、保安巡逻、远程抄表，自动喷淋等相关社区物业的智能化管理
        </div>
        <div class="list">
          <div class="item" v-for="item in list1" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <img :src="frameworkLogo1" alt="" />
      </div>
    </div>

    <div class="body2">
      <div class="left">
        <img :src="frameworkLogo2" alt="" />
      </div>
      <div class="right">
        <div class="title">移动办公高效化</div>
        <div class="text">
          将软件应用的计算和储存交由网络服务实现，真正实现了终端的解放，管理人员不必再线下处理事务，全员同一线上办公，提高办公效率
        </div>
        <div class="list">
          <div class="item" v-for="item in list2" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="body1" style="margin-bottom: 168px">
      <div class="left">
        <div class="title">社区生活智能化</div>
        <div class="text">
          在计算机网络技术的基础上，通过完善、多功能的社区综合布线系统，以成熟的信息处理技术、自动控制技术为手段，所实现的社区综合信息网络系统
        </div>
        <div class="list">
          <div class="item" v-for="item in list3" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <img :src="frameworkLogo3" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import frameworkLogo from "../../../../assets/programme/frameworkLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

import frameworkLogo1 from "../../../../assets/programme/frameworkLogo1.png";
import framework1 from "../../../../assets/programme/framework1.png";
import framework2 from "../../../../assets/programme/framework2.png";
import framework3 from "../../../../assets/programme/framework3.png";
import framework4 from "../../../../assets/programme/framework4.png";

import frameworkLogo2 from "../../../../assets/programme/frameworkLogo2.png";
import framework5 from "../../../../assets/programme/framework5.png";
import framework6 from "../../../../assets/programme/framework6.png";
import framework7 from "../../../../assets/programme/framework7.png";

import frameworkLogo3 from '../../../../assets/programme/frameworkLogo3.png'
import framework8 from "../../../../assets/programme/framework8.png";
import framework9 from "../../../../assets/programme/framework9.png";
import framework10 from "../../../../assets/programme/framework10.png";
import framework11 from "../../../../assets/programme/framework11.png";



export default {
  setup() {
    return reactive({
      frameworkLogo: frameworkLogo,
      list: [
        {
          id: 1,
          title: "平衡社会、商业和环境需求，促进社区发展和可持续性",
          logo: yesLogo,
        },
        {
          id: 2,
          title: "改善生活质量和经济福利",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "快捷告知社区居民便民实用信息。",
          logo: yesLogo,
        },
        {
          id: 4,
          title: "实时解决问题，共建和谐社区。",
          logo: yesLogo,
        },
      ],
      frameworkLogo1: frameworkLogo1,
      list1: [
        {
          id: 1,
          title: "在线缴费",
          logo: framework1,
        },
        {
          id: 2,
          title: "线上抄表",
          logo: framework2,
        },
        {
          id: 3,
          title: "智能门禁",
          logo: framework3,
        },
        {
          id: 4,
          title: "远程监控",
          logo: framework4,
        },
      ],
      frameworkLogo2: frameworkLogo2,
      list2: [
        {
          id: 1,
          title: "后台数据管理",
          logo: framework5,
        },
        {
          id: 2,
          title: "手机端移动办公",
          logo: framework6,
        },
        {
          id: 3,
          title: "硬件设备链接",
          logo: framework7,
        },
      ],
      frameworkLogo3: frameworkLogo3,
      list3: [
        {
          id: 1,
          title: "智能门禁",
          logo: framework8,
        },
        {
          id: 2,
          title: "智能监控",
          logo: framework9,
        },
        {
          id: 3,
          title: "智能停车",
          logo: framework10,
        },
        {
          id: 4,
          title: "智能充电",
          logo: framework11,
        },
      ]
    });
  },
};
</script>

<style scoped>
.framework {
  width: 1180px;
  margin: 0 auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  display: flex;
  margin-top: 40px;
}
.body .left img {
  width: 600px;
  margin-right: 80px;
}
.body .right .title {
  font-size: 16px;
  color: #333;
}
.body .right .text {
  margin-top: 30px;
  color: #495a6c;
  font-size: 14px;
}
.body .right .item-title {
  font-size: 16px;
  color: #333;
  margin-top: 50px;
}
.body .right .item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.body .right .item img {
  width: 18px;
  margin-right: 10px;
}
.body .right .item div {
  font-size: 14px;
  color: #2a3d50;
}

.body1 {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
}
.body1 .right img {
  width: 600px;
}
.body1 .left {
  width: 500px;
}
.body1 .left .title {
  font-size: 16px;
  color: #333;
}
.body1 .left .text {
  font-size: 14px;
  margin-top: 20px;
  color: #495a6c;
}
.body1 .left .list {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.body1 .left .list .item {
  text-align: center;
}
.body1 .left .list .item img {
  width: 36px;
}
.body1 .left .list .item div {
  font-size: 18px;
  color: #333;
  margin-top: 20px;
}

.body2 {
  margin-top: 80px;
  display: flex;
  justify-content: space-between;
}
.body2 .left img {
  width: 600px;
}
.body2 .right {
  width: 500px;
}
.body2 .right .title {
  font-size: 16px;
  color: #333;
}
.body2 .right .text {
  font-size: 14px;
  margin-top: 20px;
  color: #495a6c;
}
.body2 .right .list {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.body2 .right .list .item {
  text-align: center;
}
.body2 .right .list .item img {
  width: 36px;
}
.body2 .right .list .item div {
  font-size: 18px;
  color: #333;
  margin-top: 20px;
}
</style>
